// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  portId: __t.u64().primaryKey().name("port_id"),
  procure: __t.bool(),
  reasonsJson: __t.string().name("reasons_json"),
  numbersJson: __t.string().name("numbers_json"),
  checkedAt: __t.timestamp().name("checked_at"),
});
